/**
 * +field: the level badge on a mob's nameplate ("Lv 4", elite mark) in the WoW con colour for the
 * hero's level (progression levelColor). Unlevelled units (M+ keys) have none.
 */
import { levelColor } from '@keystone/progression';
import type { LevelBadge } from './fieldView';

/** CSS class per con colour (hud/field/field.css). */
export const LEVEL_CLASS = { grey: 'lv-grey', green: 'lv-green', yellow: 'lv-yellow', orange: 'lv-orange', red: 'lv-red' } as const;

export function levelBadge(mobLevel: number | undefined, heroLevel: number | undefined, elite = false): LevelBadge | null {
  if (typeof mobLevel !== 'number') return null;
  return { text: `${mobLevel}`, color: levelColor(mobLevel, heroLevel ?? mobLevel), elite };
}
